import { render } from "./CommunityItem.vue?vue&type=template&id=139c1bc2&scoped=true"
import script from "./CommunityItem.vue?vue&type=script&lang=js"
export * from "./CommunityItem.vue?vue&type=script&lang=js"

import "./CommunityItem.vue?vue&type=style&index=0&id=139c1bc2&scoped=true&lang=scss"
import "./CommunityItem.vue?vue&type=style&index=1&id=139c1bc2&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139c1bc2"]])

export default __exports__